<template>
  <div class="app-container">
    <el-form v-show="showSearch" ref="queryForm" :model="queryParams" size="small" :inline="true" label-width="78px">
      <el-form-item label="账号类型">
        <el-select v-model="queryParams.accountType" multiple collapse-tags>
          <el-option
            v-for="item in accountTypeMap"
            :label="item.label"
            :key="item.value"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户查询">
        <el-row>
          <el-select
            style="width: 35%"
            v-model="queryParams.userQueryEnum"
            clearable
            @change="queryParams.userQueryStr = ''"
          >
            <el-option v-for="(val, key) of userQueryEnumMap" :label="val" :key="key" :value="key"></el-option>
          </el-select>
          <el-input
            style="width: 65%"
            v-model="queryParams.userQueryStr"
            placeholder="请输入内容"
            clearable
            @keyup.enter.native="handleQuery"
          />
        </el-row>
      </el-form-item>
      <el-form-item label="角色">
        <el-input
          v-model="queryParams.fuzzyRoleName"
          placeholder="请输入角色"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <!-- <el-form-item label="状态">
        <el-select v-model="queryParams.enable">
          <el-option :value="true" label="启用"></el-option>
          <el-option :value="false" label="禁用"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery"> 搜索 </el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"> 重置 </el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8" type="flex" justify="end">
      <!-- <el-col :span="1.5">
        <el-button type="primary" plain size="small" @click="handleImport"> 导入 </el-button>
      </el-col> -->
      <!-- <el-col :span="1.5">
        <el-button type="primary" plain size="small" @click="handleDelete">
          导出
        </el-button>
      </el-col> -->
      <!-- <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd"> 新增用户 </el-button>
      </el-col> -->
    </el-row>

    <el-table style="margin-top: 10px" v-loading="loading" :data="userList">
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="{ row }">
          <el-button size="mini" type="text" icon="el-icon-view" @click="handleClickSee(row)"> 查看 </el-button>
          <el-button
            v-permission="['userList_edit']"
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(row)"
          >
            权限
          </el-button>
          <!-- <el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(row)">
            {{ row.enable ? '禁用' : '启用' }}
          </el-button> -->
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" prop="enable" width="50px">
        <template slot-scope="{ row }">
          <el-tag :type="row.enable ? '' : 'danger'">
            {{ row.enable ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="账号类型" align="center" prop="accountType"
        ><template slot-scope="{ row }">
          {{ accountTypeToText(row.accountType) }}
        </template></el-table-column
      >
      <el-table-column label="账号名" align="center" prop="account" />
      <el-table-column label="用户名" align="center" prop="name" />
      <el-table-column label="手机号码" align="center" prop="phoneNumber" />
      <el-table-column label="邮箱" align="center" prop="email" />
      <el-table-column label="角色" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.userRoles ? row.userRoles.map((item) => item.roleName).join(',') : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="描述" align="center" prop="description" show-overflow-tooltip />
      <el-table-column label="操作人" align="center" prop="updateUser"> </el-table-column>
      <el-table-column label="操作时间" align="center" prop="updateTime"></el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
    />

    <!-- 添加或修改用户对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body :destroy-on-close="true">
      <el-form ref="currentUserForm" :model="currentUser" :rules="rules" label-width="100px" disabled>
        <el-form-item label="账号类型">
          <el-select v-model="currentUser.accountType" style="width: 100%">
            <el-option
              v-for="item in accountTypeMap"
              :label="item.label"
              :key="item.value"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号名">
          <el-input v-model="currentUser.account" />
        </el-form-item>
        <el-form-item label="用户名">
          <el-input v-model="currentUser.name" :autosize="{ minRows: 2, maxRows: 4 }"></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="currentUser.phoneNumber" />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="currentUser.email" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio disabled v-model="currentUser.enable" :label="true">启用</el-radio>
          <el-radio disabled v-model="currentUser.enable" :label="false">禁用</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button v-re-click type="primary" @click.native.prevent="cancel"> 确 定 </el-button>
      </div>
    </el-dialog>
    <!-- 修改权限 -->
    <el-dialog title="编辑权限" :visible.sync="rolesForm" width="500px" append-to-body :destroy-on-close="true">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item prop="roleIds" label="角色">
          <el-select v-model="form.roleIds" multiple style="width: 100%">
            <el-option v-for="role in roleList" :key="role.id" :label="role.roleName" :value="role.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-model="form.shopCodes" prop="shopCodes" label="门店权限">
          <treeselect
            v-model="shopCode"
            :multiple="true"
            :limit="2"
            :options="shopOptions"
            :limitText="limitText"
            placeholder="选择门店"
            noChildrenText="无数据"
            :normalizer="normalizer"
            @close="handleCloseTree"
            @select="handleSelect"
            @deselect="handleDeselect"
          >
          </treeselect>
          <!-- <select-tree ref="selectTree" :options="menuOptions" :defaultProps="defaultProps" :defaultSelectVal='roleForm.menuAuth || []'></select-tree> -->
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="form.description" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rolesForm = false">取 消</el-button>
        <el-button v-re-click type="primary" @click.native.prevent="submitForm"> 确 定 </el-button>
      </div>
    </el-dialog>

    <upload-file
      ref="import"
      title="导入用户"
      tips="只能上传xls,xlsx文件"
      accept=".xls,.xlsx"
      :enableDownloadTemplate="true"
      :append-to-body="true"
      :api="importApi"
      :upload-sucess="getList"
      :download-api="handleDownloadImportTemp"
    />
  </div>
</template>

<script>
import {
  listUser,
  getUser,
  addUser,
  updateUser,
  deactiveUser,
  activeUser,
  getImportTemplate,
  importUser,
  accountTypeList
} from '@/api/mange/user'
import Pagination from '@/components/Pagination'
import UploadFile from '@/components/Upload/UploadFile.vue'
import constants from '@/utils/constants'
import Treeselect from '@riophae/vue-treeselect' // 使用文档：https://vue-treeselect.js.org/
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { encryptPassword } from '@/utils/encrypt.js'
import { getAllShopList } from '@/api/project/data'
import { getRoleListAll } from '@/api/mange/role'
import { integerRegExp } from '@/utils/reg-exp'
import ShopTreeSelectMinxin from '@/mixin/ShopTreeSelectMinxin'
import { userQueryEnumMap } from './config'

export default {
  name: 'User',
  components: { Pagination, Treeselect, UploadFile },
  mixins: [ShopTreeSelectMinxin],
  data() {
    var validatePass = (rule, value, callback) => {
      if (!rule.required && !value) callback()
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (!constants.passwordReg.test(value)) {
        callback(new Error(constants.passwordRegDesc))
      } else if (this.form.repeatPassword && value !== this.form.repeatPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        this.$refs['form'].clearValidate('repeatPassword')
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (!rule.required && !value) callback()
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (!constants.passwordReg.test(value)) {
        callback(new Error(constants.passwordRegDesc))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        this.$refs['form'].clearValidate('password')
        callback()
      }
    }
    var validateRole = (rule, value, callback) => {
      if (this.form.roleIds.length == 0) {
        callback(new Error('请选择角色'))
      } else {
        callback()
      }
    }
    var validateShopCodes = (rule, value, callback) => {
      if (this.shopCode.length == 0) {
        callback(new Error('请选择门店权限'))
      } else {
        callback()
      }
    }
    return {
      accountTypeMap: [],
      userQueryEnumMap,
      integerRegExp,
      // 按钮loading
      buttonLoading: false,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 用户表格数据
      userList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      rolesForm: false,
      // 查询参数
      queryParams: {
        current: 1,
        size: 20,
        fuzzyRoleName: undefined,
        enable: undefined,
        accountType: [],
        userQueryEnum: 'name',
        userQueryStr: ''
      },
      currentPwd: '',
      emialDisabled: false,
      shopCode: [],
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      },
      limitText(counnt) {
        return `+${counnt}`
      },
      roleList: [],
      // 表单参数
      form: {
        roleIds: [],
        shopCodes: []
      },
      currentUser: {},
      // 表单校验
      rules: {
        name: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' },
          {
            type: 'email',
            required: true,
            message: '请输入正确的邮箱',
            trigger: 'change'
          }
        ],
        password: [{ required: true, trigger: 'blur', validator: validatePass }],
        repeatPassword: [{ required: true, validator: validatePass2, trigger: 'blur' }],
        roleIds: [
          {
            required: true,
            message: '请选择角色',
            trigger: 'blur',
            validator: validateRole
          }
        ],
        shopCodes: [
          {
            required: true,
            message: '请选择门店权限',
            trigger: 'blur',
            validator: validateShopCodes
          }
        ]
      }
    }
  },
  created() {
    this.getList()
    this.getRoleList()
    this.getAllShopList()
    this.getAccountTypeList()
  },
  methods: {
    /** 查询用户列表 */
    getList() {
      this.loading = true
      listUser(this.queryParams).then((response) => {
        this.userList = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 查询角色列表 */
    getRoleList() {
      getRoleListAll().then((res) => {
        this.roleList = res.data
      })
    },
    // 查询门店组织
    async getAllShopList() {
      const { data } = await getAllShopList()
      this.formateShopList(data)
    },

    /** 查询账号类型 */
    getAccountTypeList() {
      accountTypeList().then((res) => {
        this.accountTypeMap = res.data
      })
    },
    accountTypeToText(key) {
      const accountTypeLabel = this.accountTypeMap.filter((item) => item.value === key)[0]
      return accountTypeLabel ? accountTypeLabel.label : key
    },
    handleCloseTree(item) {
      this.form.shopCodes = item
    },
    handleSelect(item) {
      console.log({ handleSelect: item })
    },
    handleDeselect(item) {
      console.log({ handleDeselect: item })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        name: undefined,
        gender: undefined,
        email: undefined,
        password: undefined,
        repeatPassword: undefined,
        roleIds: [],
        shopCodes: []
      }
      this.shopCode = []
      this.resetForm('form')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.current = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      const { queryParams } = this
      const queryDefault = {
        fuzzyRoleName: undefined,
        enable: undefined,
        accountType: [],
        userQueryEnum: 'name',
        userQueryStr: ''
      }
      this.queryParams = { ...queryParams, ...queryDefault }
      this.resetForm('queryForm')
      this.handleQuery()
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.emialDisabled = false
      this.updateRules(true)
      this.title = '添加用户'
    },
    handleClickSee(row) {
      this.currentUser = row
      this.open = true
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.loading = true
      this.reset()
      const id = row.id || this.ids
      getUser(id).then((response) => {
        const { data } = response
        this.loading = false
        this.form = { ...this.form, ...data }
        if (data.userRoles && data.userRoles.length > 0) {
          this.form.roleIds = data.userRoles.map((item) => item.id)
        }
        if (data.userShops && data.userShops.length > 0) {
          const codeArr = data.userShops.map((item) => item.id)
          this.shopCode = codeArr
          this.form.shopCodes = codeArr
        }
        this.rolesForm = true
        // this.emialDisabled = true
        // this.updateRules(false)
        // this.title = '修改用户'
      })
    },

    /** 提交按钮 */
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const apiFn = this.form.id != null ? updateUser : addUser
          this.buttonLoading = true
          const { password, repeatPassword, shopCodes } = this.form
          let params = { ...this.form }
          params.shopCodes = this.getSelectedShopId(shopCodes)
          if (password && repeatPassword) {
            params = {
              ...params,
              password: encryptPassword(password),
              repeatPassword: encryptPassword(repeatPassword)
            }
          }
          apiFn(params)
            .then((response) => {
              this.msgSuccess(this.form.id != null ? '修改成功' : '新增成功')
              this.rolesForm = false
              this.getList()
            })
            .finally(() => {
              this.buttonLoading = false
            })
        }
      })
    },
    /** 启用/禁用按钮操作 */
    handleDelete(row) {
      const userId = row.id || this.ids
      this.$confirm(`确认${row.enable ? '禁用' : '启用'}该账号吗？`)
        .then(() => {
          this.loading = true
          const fn = row.enable ? deactiveUser : activeUser
          return fn(userId)
        })
        .then(() => {
          this.loading = false
          this.msgSuccess('操作成功')
          this.getList()
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    updateRules(required) {
      this.rules.password[0].required = required
      this.rules.repeatPassword[0].required = required
    },
    pwdInputChange(val) {
      if (this.form.id != null) {
        this.updateRules(val ? true : false)
      }
    },
    // 校验手机号码格式
    checkPhone(value) {
      this.form.phoneNumber = this.integerRegExp.test(parseInt(value)) ? String(parseInt(value)).replace('.', '') : ''
    },
    handleImport() {
      this.$refs.import.visible = true
    },
    importApi(data) {
      console.log({ data })
      return importUser({ data })
    },
    /** 下载模板操作 */
    handleDownloadImportTemp() {
      getImportTemplate().then((response) => {
        this.download(response.data, '导入用户账号模板')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
// .app-container {
//   overflow-y: auto;
// }
.is-error {
  margin-bottom: 32px;
}
</style>
